module.exports = __webpack_public_path__ + "static/img/gaozhonglishi12.ed515745.jpg";